import { Pivot, PivotItem } from "@fluentui/react";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import React from "react";
import { ObjectPanelTabs } from "../coobjects/co-panel/ObjectPanelComponent";

interface PivotObjectProps {
  isEdit: boolean;
  isComponentInstance?: boolean;
  selectedKey: number;
  onClickPivot: (key) => void;
  objectType: string;
  items: ObjectPanelTabs[];
  defaultTabName: string;
}

export const PivotObject = (props: PivotObjectProps) => {
  const { isEdit, isComponentInstance, selectedKey, onClickPivot, items } = props;
  if (isEdit || isComponentInstance) {
    return (
      <Pivot selectedKey={String(selectedKey)} onLinkClick={onClickPivot} headersOnly={true}>
        {items ? (
          items.map((i) => <PivotItem key={`pivot_${i.key}`} itemKey={i.key} headerText={formatMessage(i.name)} />)
        ) : (
          <PivotItem itemKey={"0"} headerText={props.defaultTabName} />
        )}
      </Pivot>
    );
  }
  return null;
};
